"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campi-bisenzio": {
    "3af8dadd": [{
      "hkey": "a1a6d546",
      "slug": "capalle-la-villa",
      "name": "Capalle-La Villa",
      "primary": true,
      "skipSearch": false
    }],
    "capalle": [{
      "hkey": "a1a6d546",
      "slug": "capalle-la-villa",
      "name": "Capalle-La Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "01521a3d": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "indicatore": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campi-bisenzio"
    }],
    "e2d5e0e8": [{
      "hkey": "a1a6d546",
      "slug": "capalle-la-villa",
      "name": "Capalle-La Villa",
      "primary": true,
      "skipSearch": false
    }],
    "la-villa": [{
      "hkey": "a1a6d546",
      "slug": "capalle-la-villa",
      "name": "Capalle-La Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campi-bisenzio"
    }],
    "e03005c0": [{
      "hkey": "e5283481",
      "slug": "campi-bisenzio",
      "name": "Campi Bisenzio",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-nuovo": [{
      "hkey": "e5283481",
      "slug": "campi-bisenzio",
      "name": "Campi Bisenzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "731be21f": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "san-cresci": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "04061362": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "san-giusto": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campi-bisenzio"
    }],
    "f7c79056": [{
      "hkey": "8da01257",
      "slug": "san-lorenzo-san-martino",
      "name": "San Lorenzo-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "8da01257",
      "slug": "san-lorenzo-san-martino",
      "name": "San Lorenzo-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "23544f79": [{
      "hkey": "8da01257",
      "slug": "san-lorenzo-san-martino",
      "name": "San Lorenzo-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "8da01257",
      "slug": "san-lorenzo-san-martino",
      "name": "San Lorenzo-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campi-bisenzio"
    }],
    "bbb08a8b": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "san-piero-a-ponti": [{
      "hkey": "ade32a92",
      "slug": "san-cresci-san-giusto-san-piero-a-ponti",
      "name": "San Cresci-San Giusto-San Piero a Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campi-bisenzio"
    }],
    "5648f2e7": [{
      "hkey": "244f2ce8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "244f2ce8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;